import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=953f856c&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('953f856c')) {
      api.createRecord('953f856c', component.options)
    } else {
      api.reload('953f856c', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=953f856c&", function () {
      api.rerender('953f856c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2a5wxohQ4zPX9/JS/videoIframe.vue"
export default component.exports